import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "workSpaces";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
